export default "__VITE_ASSET__CWedcVAv__"